import React from 'react';
import reform from 'components/Reform';
import Fieldset from 'components/Fieldset';
import Button from 'components/Button';
import FormError from 'components/FormError';

const ResetPasswordRequestForm = reform({
  forceErrorsVisible: true
})(
  ({
    requestResetDone,
    instructions,
    email,
    onSubmit,
    handleFocus,
    loading,
    formValid,
    errorMessage,
    handleChange
  }) => (
    <form name="resetPasswordRequest" className="resetPasswordform" onSubmit={onSubmit}>
      <Fieldset
        field={email}
        name="email"
        inputType="email"
        labelText="Email"
        autoComplete="email"
        onChange={handleChange}
        onFocus={handleFocus}
        hideAsterisk
      />
      <div className="fieldset fieldset--fullflex">
        {!requestResetDone || loading ? (
          <Button
            disabled={!formValid}
            loading={loading}
            title="Reset password"
            buttonText="Reset password"
            type="submit"
          />
        ) : (
          <>
            <span className="fieldset__message">{instructions}</span>
            <img alt="Verified" className="verified" src="/assets/images1/green-tick.png" />
          </>
        )}
      </div>
      <FormError errorMessage={errorMessage} />
    </form>
  )
);

export default ResetPasswordRequestForm;
